import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { Alert } from "reactstrap";
// eslint-disable-next-line import/no-cycle
import { ExtractReportContext } from "../ExtractReportContext";
import { Link } from "react-router-dom";
import DataTable from "components/DataTable";

const DetailsModal = ({
  content,
  title,
  subtitle,
  button,
  reportlaststatus,
  createdBy,
  modifiedBy,
  reportData
}) => {
  const columns = [
    {
      Header: "STATUS",
      accessor: "runStatus",
      Cell: value => {
        return (
          <div
            data-tag="allowRowEvents"
            className={`pilltext pilltext--${value.row.values.runStatus}`}
          >
            {value.row.values.runStatus}
          </div>
        );
      }
    },
    {
      Header: "START TIME",
      accessor: "startTime"
    },
    {
      Header: "END TIME",
      accessor: "endTime"
    },
    {
      Header: "DURATION",
      accessor: "duration"
    },
    {
      Header: "ACTIONS",
      accessor: "actions",
      disableSortBy: true
    }
  ];

  const settings = {
    expanded: "",
    sortBy: [
      {
        id: "runStatus",
        desc: false
      }
    ],
    globalFilter: "",
    hiddenColumns: ["id"]
  };

  const { runReportStatus } = useContext(ExtractReportContext);

  const editLink = `/app/account/${reportData.accountid}/dags/${reportData.dagid}/reports/${reportData.reportid}`;

  const handleButtonClick = () => {
    button();
    // toggle modal can be added here
  };

  return (
    <section>
      {runReportStatus === "success" && (
        <Alert color="success">Extract Queued</Alert>
      )}
      {runReportStatus === "error" && (
        <Alert color="danger">Extract Failed to Run</Alert>
      )}
      <header className="slide-pane__content--header">
        <div>
          <h2>{title}</h2>
          <div>{subtitle}</div>
          <div style={{ marginTop: 10 }}>
            <div>Created by: {createdBy}</div>
            <div>Modified by: {modifiedBy}</div>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <Link
            to={editLink}
            className="pillbutton"
            tabIndex="0"
            style={{ marginRight: 10, padding: "10px 20px" }}
          >
            Edit
          </Link>

          <button
            disabled={
              (runReportStatus === "loading" ||
                reportlaststatus === "QUEUED" ||
                reportlaststatus === "INPROGRESS") &&
              true
            }
            type="button"
            className={
              runReportStatus === "loading"
                ? "pillbutton pillbutton--loading"
                : "pillbutton"
            }
            onClick={handleButtonClick}
          >
            {runReportStatus === "loading" ? (
              <>
                <FontAwesomeIcon icon={faSync} spin /> Run Now
              </>
            ) : (
              "Run Now"
            )}
          </button>
        </div>
      </header>

      <div style={{ padding: "0px 100px 100px 100px", overFlowY: "scroll" }}>
        <section>
          <DataTable
            columns={columns}
            data={content}
            options={settings}
            showGlobalSearch={false}
          />
        </section>
      </div>
    </section>
  );
};

DetailsModal.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.arrayOf.isRequired,
  button: PropTypes.func,
  reportlaststatus: PropTypes.string
};

DetailsModal.defaultProps = {
  title: "",
  subtitle: "",
  button: null,
  reportlaststatus: null
};

export default DetailsModal;
